export default __webpack_public_path__ + "static/Gerard-Ramirez-bw-d860380d2e951fe6be28254132d36dca.png";